export enum UserRole {
  Admin = 0,
  User = 1,
}

export const userRoleOptions = [
  { label: 'Admin', value: UserRole.Admin },
  { label: 'User', value: UserRole.User }
];